import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { SITE_LINKS } from '@shared/constants/site-links.constants';
import { STORAGE } from '@shared/constants/storage.constants';
import { LoggedInUser } from '@shared/models/user/user.model';
import { AuthService } from '@shared/services/auth/auth.service';
import { StorageService } from '@shared/services/storage/storage.service';
import { LoggedInUserStore } from '@shared/stores/logged-in-user.store';
import { buildUrl } from '@shared/utilities/common.utils';

@Component({
    selector: 'avenir-header-user-menu',
    imports: [],
    templateUrl: './header-user-menu.component.html',
    styleUrl: './header-user-menu.component.scss'
})
export class HeaderUserMenuComponent {
  @Input() clientId!: string;
  @Input() testIdPrefix?: string;
  user!: LoggedInUser;
  displayMenu: boolean = false;
  profileUrl: string = '';

  constructor(
    private storageService: StorageService,
    private authService: AuthService,
    public loggedInUserStore: LoggedInUserStore,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.user = this.loggedInUserStore.getUser();
    this.profileUrl = buildUrl(SITE_LINKS.PROFILE.BASE, this.clientId, this.user.userId);

    console.log(this.profileUrl);
  }

  navigateTo(url: string) {
    this.router.navigateByUrl(url);
  }

  onLogout(): void {
    this.authService.logout()
      .subscribe({
        next: (data) => {
          console.log(data);
        },
        error: (error) => {
          console.error(error);
        }
      });
  }
}
